import { toPlain } from '@utils/toPlain';
import { defaultUserModel } from '@const/defaultUserModel';

function state() {
  return {
    user: toPlain(defaultUserModel),
    listTypes: [],
    todayTasks: [],
    todayTasksCount: 0,
    unsavedDataProtection: false,
    sendMeCopy: false,
    drawerOpen: true,
    lastCaseType: null,
  };
}

export default state;
